/* eslint camelcase: 0 */
import { ZipcloudGatewayBase } from './base'
import { toSearchProps } from './translator/search'
import { IAddressProps } from '@/entities/Zipcloud/Address'
import { FetchSearch } from '@/infrastructure/network/Zipcloud/requests/search'
import { Request } from '@/infrastructure/network/Zipcloud/schema/models'

export default class Search extends ZipcloudGatewayBase {
  async FetchSearch(query?: Request): Promise<IAddressProps | null> {
    const response = await this.apiClient.request(new FetchSearch(query))
    if (response.status === 200) {
      return response.results?.map(toSearchProps)[0]
    }
    return null
  }
}
